import { loadMedClinicPatients } from './../../../../core/store/medclinic/medclinic.actions';
import { FormBuilderState } from './../../../../core/store/form-builder/form-builder.reducer';
import { FBFormModel } from './../../../../models/formBuilderModels';
import { BaseComponent } from './../../../../core/abstracts/baseComponent';
import { BenefitsState } from './../../../../core/store/benefits/benefits.reducer';
import { BenefitPlanModel } from './../../../../models/benefitsModels';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { Component, OnInit, signal, computed } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { Actions, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { MultiSelect } from 'primeng/multiselect';
import { AlertService } from '../../../../shared/services/alert.service';
import { deepClone, downloadFile, getTimeStampString } from '../../../../helpers/utils';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { tap } from 'rxjs';
import { DateRangeModel } from '../../../../models/dateRangeModel';
import { DropdownFilterService } from '../../../../core/services/dropdown-filter.service';
import { getFBFormTable } from 'src/app/core/store/form-builder/form-builder.actions';
import { CreateEmployeePatientModel } from 'src/app/models/medClinicModels';

@Component({
    selector: 'app-medclinic-patients-list',
    templateUrl: './medclinic-patients-list.component.html',
    styleUrls: ['./medclinic-patients-list.component.scss'],
    standalone: false
})
export class MedclinicPatientsListComponent extends BaseComponent implements OnInit {

  medclinicPatientsList: CreateEmployeePatientModel[];
  canEdit: boolean;
  loadingPatients = false;
  filter: any;

  formNameFilter;
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });
  constructor(
    private actions$: Actions,
    private alertService: AlertService,
    private store: Store<State>,
    private router: Router,
    private confirmationService: ConfirmationService,
    private dropdownFilterService: DropdownFilterService
  ) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canEdit = permissionIDs && !!permissionIDs.find(p => p === 11001);
      }),
      this.store.select(s => s.medClinicState.patientsList).subscribe(medclinicPatientsList => {
        if (medclinicPatientsList) {
          this.medclinicPatientsList = medclinicPatientsList;
          this.totalRecords.set(medclinicPatientsList.length);
        }
      }),

      this.store.select(s => s.medClinicState.loadingPatients).subscribe(loadingPatients => {
        this.loadingPatients = loadingPatients;
      }),
    );
    this.store.dispatch(loadMedClinicPatients());
  }

  accessClientPortal() {
    //Link to client portal
  }

}

